import type { HtmlTransformer } from '@change-corgi/core-react/html';

/**
 * AI generated comment:
 * Inserts U+200B after `</a>` when another `<a>` follows so screen readers treat adjacent links as
 * separate navigation targets. This only adds boundaries; it does not split or create links.
 * Ticket: https://change.atlassian.net/browse/CHANGE-87830
 */
// Keep this allowlist aligned with tags that survive `Html` sanitization.
const INLINE_PHRASING_GAP_TAGS = 'strong|b|em|i';

const INLINE_BLOCK_GAP_TAGS = 'p';

const INLINE_GAP_TAGS = `${INLINE_PHRASING_GAP_TAGS}|${INLINE_BLOCK_GAP_TAGS}`;

const ADJACENT_ANCHOR_GAP_TOKEN =
	'(?:' +
	'\\s|::|\\||\\/|·|•|,|;|–|—|&nbsp;|&#160;|&#xA0;|' +
	`</(?:${INLINE_GAP_TAGS})>|` +
	`<(?:${INLINE_GAP_TAGS})\\b[^>]*>` +
	')';

const ADJACENT_ANCHOR_GAP = new RegExp(`</a>(${ADJACENT_ANCHOR_GAP_TOKEN}+)(?=<a\\b)`, 'gi');

/**
 * AI generated comment:
 * Two-pass insertion:
 * 1) `</a>${gap}<a` -> `</a>\u200B${gap}<a` where gap tokens include whitespace, common delimiters,
 *    nbsp entities, and allowed `<strong|b|em|i|p>` wrappers.
 * 2) `</a><a` -> `</a>\u200B<a` for tight adjacency with no gap token.
 */
function insertBoundaryBetweenAdjacentAnchors(html: string): string {
	let out = html.replace(ADJACENT_ANCHOR_GAP, (_match, gap: string) => `</a>\u200B${gap}`);
	out = out.replace(/<\/a>(?=<a\b)/gi, '</a>\u200B');
	return out;
}

export function transformDescriptionHtmlForAdjacentLinkNavigation(html: string): string {
	return insertBoundaryBetweenAdjacentAnchors(html);
}

export const descriptionAdjacentAnchorsAccessibilityTransformer: HtmlTransformer = {
	transformHtml: transformDescriptionHtmlForAdjacentLinkNavigation,
};
